/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { MouseEventHandler } from "react";
import { QuestionOption } from "src/components/refactored-survey/QuestionDefinition";
import RadioButton from "src/design-system/components/RadioButton/RadioButton";

interface RadioQuestionOptionsProps {
  options: QuestionOption[];
  questionId: string;
  getQuestionAnswerKey: () => string;
  handleClick: MouseEventHandler<HTMLElement>;
}

function RadioQuestionOptions({
  options,
  questionId,
  getQuestionAnswerKey,
  handleClick,
}: RadioQuestionOptionsProps) {
  return (
    <>
      {options.map((option) => (
        <RadioButton
          key={option.id}
          onClick={handleClick}
          checked={option.id === getQuestionAnswerKey()}
          value={option.id}
          name={questionId}
          id={option.id}
        >
          {option.text}
        </RadioButton>
      ))}
    </>
  );
}

export default RadioQuestionOptions;
